import React, { useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import { jobs } from "../../common/data";
import { Modal } from "../../components/Modal";
// import { Button } from "../../components/Button";
import { useTranslation } from "react-i18next";
import { jobs } from "../joinus-jobs/jobs";
import "./styles.less";
import { ModalUsePortal } from "../../components/ModalUsePortal";

const FormModal = (props) => {
  const { visible, setVisible, currentJob } = props;
  const { t } = useTranslation();

  return (
    <ModalUsePortal show={visible}>
      <div className="consult-form-modal">
        <div className="apply-modal">
          <i
            onClick={() => setVisible(false)}
            className="icon authing-icon authing-guanbi"
          />
          <div className="apply-title">{t("common.form.apply-title")}</div>
          <div className="apply-position-label">
            {t("common.form.apply-position")}
          </div>
          <div className="apply-position-value">{t(currentJob.title)}</div>
          <div className="apply-method">{t("common.form.apply-method")}</div>
          <div className="apply-info">
            {t("common.form.mail-address")}：
            <a
              href={`mailto:mayanjun@authing.com?subject=姓名-${currentJob.title}`}
            >
              mayanjun@authing.com
            </a>
          </div>
          <div className="apply-info">{t("common.form.mail-title")}</div>
          <div className="apply-info">{t("common.form.mail-content")}</div>
        </div>
      </div>
    </ModalUsePortal>
  );
};

export const JoinusDetail = (props) => {
  const nav = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();
  const jobLink = (id) => {
    nav(`/joinus/${id}`);
  };
  const linkPath = (path) => {
    nav(path);
  };
  const [visible, setVisible] = useState(false);
  const list = [
    { id: 1, title: `${t("joinus.jobs.job1.title")}` },
    { id: 2, title: `${t("joinus.jobs.job2.title")}` },
    { id: 3, title: `${t("joinus.jobs.job3.title")}` },
    { id: 4, title: `${t("joinus.jobs.job4.title")}` },
    { id: 5, title: `${t("joinus.jobs.job5.title")}` },
    { id: 6, title: `${t("joinus.jobs.job6.title")}` },
    { id: 7, title: `${t("joinus.jobs.job7.title")}` },
    { id: 8, title: `${t("joinus.jobs.job8.title")}` },
    { id: 9, title: `${t("joinus.jobs.job9.title")}` },
    { id: 10, title: `${t("joinus.jobs.job10.title")}` },
    { id: 11, title: `${t("joinus.jobs.job11.title")}` },
    { id: 12, title: `${t("joinus.jobs.job12.title")}` },
    { id: 13, title: `${t("joinus.jobs.job13.title")}` },
    { id: 14, title: `${t("joinus.jobs.job14.title")}` },
    { id: 15, title: `${t("joinus.jobs.job15.title")}` },
    { id: 16, title: `${t("joinus.jobs.job16.title")}` },
    { id: 17, title: `${t("joinus.jobs.job17.title")}` },
    { id: 18, title: `${t("joinus.jobs.job18.title")}` },
    { id: 19, title: `${t("joinus.jobs.job19.title")}` },
  ];
  const currentJob = useMemo(() => {
    let _currentJob;
    jobs.forEach((item) => {
      if (item.id === Number(id)) {
        _currentJob = item;
      }
    });
    return _currentJob;
  }, [id]);

  return (
    <div className="joinus-content">
      <section className="joinus-detail">
        <div className="inner">
          <div className="nav-bar">
            <span
              onClick={() => {
                linkPath("/about");
              }}
            >
              {t("joinus.job-detail.navbar.nav0")}
              <span style={{ paddingRight: 8, paddingLeft: 8 }}>/</span>
            </span>
            <span
              onClick={() => {
                linkPath("/joinus");
              }}
            >
              {t("joinus.job-detail.navbar.nav1")}{" "}
              <span style={{ paddingRight: 8, paddingLeft: 8 }}>/</span>
            </span>
            <span style={{ color: "#666666", cursor: "default" }}>
              {t(currentJob?.title)}
            </span>
          </div>
          <div className="job-content">
            <div className="job-text">
              <div className="job-title">{t(currentJob?.title)}</div>
              <div className="job-time">
                {t("joinus.job-detail.publishtimer")} : {currentJob?.time}
              </div>

              <div className="job-require">
                <div className="job-label">
                  {t("joinus.job-detail.label-description")}
                </div>
                {(currentJob?.desc || []).map((item) => {
                  return <div className="item">{t(item)}</div>;
                })}
              </div>
              <div className="job-description">
                <div className="job-label">
                  {t("joinus.job-detail.label-skills")}
                </div>

                {(currentJob?.skills || []).map((item) => {
                  return <div className="item">{t(item)}</div>;
                })}
              </div>
              <div className="job-email">
                <div className="apply-info">
                  {t("common.form.mail-address-info")}：
                  <a
                    href={`mailto:mayanjun@authing.com?subject=姓名-${currentJob.title}`}
                  >
                    mayanjun@authing.com
                  </a>
                </div>
              </div>
            </div>

            <div className="job-apply">
              <div
                className="apply-button"
                onClick={() => {
                  setVisible(true);
                }}
              >
                {t("joinus.job-detail.button-apply")}
              </div>
              <div className="apply-other">
                <div className="title">
                  <span>{t("joinus.job-detail.label-newjob")}</span>
                </div>
                {list.map((item) => {
                  return (
                    <div
                      className="item"
                      onClick={() => {
                        jobLink(item.id);
                      }}
                    >
                      {item.title}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </section>

      <FormModal {...{ visible, setVisible, currentJob }} />
    </div>
  );
};
